// extracted by mini-css-extract-plugin
export default {"marketingOptInCheckbox":"MarketingOptInCheckbox_marketingOptInCheckbox__k9RhS"};